import { StoryblokComponent, StoryblokComponentList } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { TagStoryblok } from "~/generated/sb/blok-types";
import styles from "./TagBlok.module.css";

export const TagBlok = ({ blok, preview }: { blok: TagStoryblok; preview: boolean }) => {
	return (
		<BlokWrap editable={blok} asChild>
			<span className={styles["tag-link"]}>
				{blok?.text && <StoryblokComponentList bloks={blok?.text} preview={preview} />}

				{blok?.media?.[0] && (
					<div className={styles["image-wrapper"]}>
						<div className={clsx(styles["tag-image"])}>
							<StoryblokComponent blok={blok?.media?.[0]} preview={preview} />
						</div>
					</div>
				)}
			</span>
		</BlokWrap>
	);
};
